import { render, staticRenderFns } from "./PropertyDetailsCard.vue?vue&type=template&id=0fdc51e8&scoped=true"
import script from "./PropertyDetailsCard.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetailsCard.vue?vue&type=style&index=0&id=0fdc51e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc51e8",
  null
  
)

export default component.exports